import Vue, { VueConstructor } from 'vue';
import Router, { RouteConfig, RouterOptions, Route } from 'vue-router';

const RouterInstall = Router.install;

interface WxIRouterOptions extends RouterOptions {
    privileges: () => string[];
    isAuthenticated: () => boolean;
    notAuthenticatedRoute?: string;
    notAuthorizedHndlr?: () => void;
    notAuthorizedMessage?: string;
}

const DEFAULT_NOT_AUTHORIZED_MESSAGE = `Sie haben keine Berechtigung diese Seite aufzurufen.
<br>
<br>
<b>Der Zugriff wird geloggt und gemeldet!!!</b>`;

const DEFAULT_NOT_AUTHENTICATED_ROUTE = '/login';

class WxRouter extends Router {
    private routes: RouteConfig[];
    private privileges: () => string[];
    private isAuthenticated: () => boolean;
    private notAuthenticatedRoute: string;
    private notAuthorizedHndlr: () => void;
    private notAuthorizedMessage: string;
    constructor(options: WxIRouterOptions) {
        super(options);
        this.routes = options.routes || [];
        this.privileges = options.privileges;
        this.isAuthenticated = options.isAuthenticated;
        this.notAuthenticatedRoute = options.notAuthenticatedRoute || DEFAULT_NOT_AUTHENTICATED_ROUTE;
        this.notAuthorizedMessage = options.notAuthorizedMessage || DEFAULT_NOT_AUTHORIZED_MESSAGE;
        this.notAuthorizedHndlr = options.notAuthorizedHndlr || this.defaultNotAuthorizedHndlr;
        this.beforeEach(this.defaultBeforeEach.bind(this));
    }

    public allowedRoutes() {
        return this.flattenRoutes(this.routes);
    }

    private flattenRoutes(aRoutes: RouteConfig[], arr?: string[]): string[] {
        const findLastParameter = /^(.*)\/:.*$/;
        return aRoutes.reduce((currArr, item) => {
            if (item.children) {
                currArr = this.flattenRoutes(item.children, currArr);
            }
            const privilege = item.meta ? item.meta.privilege : '';
            if (!!privilege && this.privileges().includes(privilege)) {
                let path = item.path;
                // exclude last parameter when found (e.g. xxx/user/:id)
                const match = item.path.match(findLastParameter);
                if (match && match[1]) path = match[1];
                currArr.push(path);
            }
            return currArr;
        }, arr || []);
    }

    private defaultBeforeEach(to: Route, from: Route, next: any) {
        const authRequired = to.meta.privilege !== 'PUBLIC' && to.meta.privilege !== 'SES_EXEC_PUBLIC';

        if (authRequired && !this.isAuthenticated()) {
            return next(this.notAuthenticatedRoute);
        }

        if (authRequired && !(this.privileges() as string[]).includes(to.meta.privilege as string)) {
            this.notAuthorizedHndlr();
            return next(false);
        }

        return next();
    }

    private defaultNotAuthorizedHndlr() {
        return Vue.prototype.$confirm(this.notAuthorizedMessage, {
            title: 'Zugriff verweigert!',
            buttonTrueText: 'Verstanden',
            buttonFalseText: '',
            color: 'error',
            icon: 'error',
            width: 350,
        });
    }
}

WxRouter.install = (aVue: VueConstructor) => {
    RouterInstall(aVue);
};

export { WxRouter as WxRouterPlugin };
